import React from 'react';
import {
  Flex,
  Grid,
  GridItem,
  SimpleGrid,
  Divider,
  Spacer,
  Textarea,
} from '@chakra-ui/react';
import styles from '../styles/mobileBannerStyles';
import theme from '../config/color';
import UncontrolledEditor from '../components/textEditor/textEditor';

import {
  customSwtich,
  customInputLabel,
  customUpdateCancelBtn,
} from '../components/createAppVersionComponent/createAppVersionComponent';
import { dropdownCustom } from '../components/bannerComponents/customBannerComponents';
import { renderCopyRight } from '../components/aboutUsComponent/customCompoent';
import {
  customTextarea,
  MiniHeader,
} from '../components/common/customComponent';
import { customSaveButton } from '../components/inboxMessagingComponent';

const CreateSoftpinImport = () => {
  console.log('CreateSoftpinImport gg bro');
  return (
    <Flex flexDirection={'column'} backgroundColor={'#FAFDFB'} height={'80vh'}>
      {MiniHeader({
        title: 'Upload Softpin File',
        path: 'Dashboard / Softpin Import / Upload Softpin File',
      })}

      <Flex {...styles.parentFlex}>
        <SimpleGrid width={'100%'} columns={2} spacingX={'50px'}>
          {customInputLabel({
            title: 'For Update?',
            // mandatory: true,
          })}
          {customInputLabel({
            title: 'Please select an Excel file that contains the softpin data',
            // mandatory: true,
            type:"file"
          })}
        </SimpleGrid>

        {customUpdateCancelBtn({
          title1: 'Submit',
          title2: 'Cancel',
        })}
      </Flex>
      <Spacer />
      <Divider orientation="horizontal" marginTop={5} marginBottom={2} />
      <Flex position={'sticky'} marginLeft={4}>
        {renderCopyRight()}
      </Flex>
    </Flex>
  );
};

export default CreateSoftpinImport;
